'use client'

import { usePathname } from 'next/navigation'
import { CompanyInfoProvider } from '@/contexts/CompanyInfoContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { WebSocketProvider } from '@/contexts/WebSocketContext'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import FloatingWhatsApp from '@/components/FloatingWhatsApp'
import ChatWidget from '@/components/chat/ChatWidget'
import ChatWindowManager from '@/components/chat/ChatWindowManager'
import CallNotificationHandler from '@/components/chat/CallNotificationHandler'
import DynamicMetadata from '@/components/DynamicMetadata'

interface ConditionalLayoutProps {
  children: React.ReactNode
}

export default function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const pathname = usePathname()
  const isCRMPage = pathname?.startsWith('/crm')
  const isMeetPage = pathname?.startsWith('/meet')
  const isExamPage = pathname?.startsWith('/about/career/exam')
  
  // Authentication pages that should not show header/footer
  const isAuthPage = ['/login', '/register', '/forgot-password', '/reset-password'].includes(pathname || '')

  return (
    <CompanyInfoProvider>
      <AuthProvider>
        <WebSocketProvider>
        <DynamicMetadata />
        {isCRMPage || isAuthPage || isMeetPage || isExamPage ? (
          <>{children}</>
        ) : (
          <>
            <Header />
            {children}
            <Footer />
            <FloatingWhatsApp />
          </>
        )}
        
        {/* Global Chat Components - Available on all pages except auth and meet */}
        {!isAuthPage && !isMeetPage && (
          <>
            <ChatWidget />
            <ChatWindowManager />
            <CallNotificationHandler />
          </>
        )}
        </WebSocketProvider>
      </AuthProvider>
    </CompanyInfoProvider>
  )
}